export default __webpack_public_path__ + "static/media/imatge-slider-portada-1.6088863b.jpg";